import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
// import "@fortawesome/fontawesome-free/css/all.min.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
// import { AuthProvider } from "./context/AuthContext";
const container = document.getElementById("root");
const app = (
  <React.StrictMode>
    {/* <AuthProvider> */} <App />
    {/* </AuthProvider> */}
  </React.StrictMode>
);

// public/index.html always ships a small placeholder inside #root (a hidden
// <h1> fallback for pre-JS clients), so `#root` having child nodes does NOT
// by itself mean this page was prerendered — hydrating against that
// placeholder would mismatch the real component tree and fail to render.
// frontend/scripts/prerender.js stamps `data-prerendered` on <html> only on
// pages it actually captured full app markup for, so that's the reliable
// signal to hydrate instead of render fresh. Local dev (`npm start`) and any
// route without a prerendered snapshot never carry this attribute, so they
// keep using the plain createRoot path unchanged.
if (document.documentElement.hasAttribute("data-prerendered")) {
  ReactDOM.hydrateRoot(container, app);
} else {
  ReactDOM.createRoot(container).render(app);
}

reportWebVitals();
